module.exports = __webpack_public_path__ + "img/avatar13_11zon.a63ef164.webp";